import { MarketplaceItemFormWrapper } from '../../components'

export default function MarketplaceItemFormPage() {
  return <MarketplaceItemFormWrapper />
}
